var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',_vm._b({staticClass:"phone-code",attrs:{"type":"primary","disabled":_vm.disabled,"loading":_vm.codeLoading},on:{"click":_vm.getCode}},'el-button',_vm.$attrs,false),[_vm._v(_vm._s(_vm.codeText))])
}
var staticRenderFns = []

export { render, staticRenderFns }